import {
    ActionIcon,
    Button,
    ActionIconProps as MantineActionIconProps,
    MantineBreakpoint,
    ButtonProps as MantineButtonProps,
    PolymorphicComponentProps,
} from '@mantine/core';

type ButtonProps = PolymorphicComponentProps<'a', MantineButtonProps> & {
    href?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
};

type ActionIconProps = PolymorphicComponentProps<'a', MantineActionIconProps> & {
    href?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
};

const ResponsiveActionButton = ({
    icon,
    breakpoint,
    label,
    buttonProps,
    actionIconProps,
}: {
    icon: React.ReactNode;
    breakpoint: MantineBreakpoint;
    label: React.ReactNode;
    buttonProps?: ButtonProps;
    actionIconProps?: ActionIconProps;
}) => {
    return (
        <>
            <ActionIcon hiddenFrom={breakpoint} {...actionIconProps}>
                {icon}
            </ActionIcon>
            <Button visibleFrom={breakpoint} leftSection={icon} {...buttonProps}>
                {label}
            </Button>
        </>
    );
};

export { ResponsiveActionButton };
